import { ElementType } from '@editor2/types/pageElements';

export const ALLOWED_IN_QUESTION_DECK = [
	ElementType.MCQuestion,
	ElementType.MCQuestionPool,
	ElementType.Poll,
	ElementType.PollResults
];

export const MAX_MCQ_IN_QUESTION_DECK = 10;
